import { reportPageAction } from '@/lib/newrelic';

const analytics = {
  track(event: string, properties?: Record<string, unknown>) {
    const attributes: Record<string, string | number | boolean> = {};

    if (properties) {
      for (const [key, value] of Object.entries(properties)) {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
          attributes[key] = value;
        }
      }
    }

    reportPageAction(event, attributes);
  },
};

export default analytics;
